// This file is auto-generated via CI, do not edit by hand!
export enum PreisModell {
  PM_2024_ENTERPRISE_V1 = '2024_enterprise_v1',
  PM_2024_FREE_V1 = '2024_free_v1',
  PM_2024_TEAM_V1 = '2024_team_v1',
}
